export default {
  methods: {
    $transactionStatusColor(status) {
      let statusColor;
      switch (status) {
        case /^COMPLETE|Overpaid|Over_paid|SUCCESS|^ACTIVE/i.test(status)
          ? status
          : "":
          statusColor = { color: "successBg", textColor: "success" };
          break;
        case /EXPIRE|ERROR|INCOMPLETE|CANCEL|FAILED|INACTIVE/i.test(status)
          ? status
          : "":
          statusColor = { color: "errorBg", textColor: "error" };
          break;
        case /Underpaid|Under_paid|warning/i.test(status) ? status : "":
          statusColor = { color: "warningBg", textColor: "warning" };
          break;
        case null:
          statusColor = { color: "transparent", textColor: "transparent" };
          break;
        default:
          statusColor = { color: "infoBg", textColor: "info" };
      }
      return statusColor;
    }
  }
};
